export default __webpack_public_path__ + "static/media/ocean-import-dark.f04941a1.svg";